import { render, staticRenderFns } from "./DsnData.vue?vue&type=template&id=ad857436&"
import script from "./DsnData.vue?vue&type=script&lang=js&"
export * from "./DsnData.vue?vue&type=script&lang=js&"
import style0 from "./DsnData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports